import './primary-layout.styles';

import initHeader from '@/templates/header/header';
import initFooter from '@/templates/footer/footer';

/** @param {{ 
 *    headerMode: import('@/templates/header/header').Mode 
 * }} param0 
 */
export default function initPrimaryLayout({ headerMode = 'default' } = {}) {
   initHeader(headerMode);
   initFooter();
}